import { resolveDateRangeParams } from "utils/dateRangeParams";

const NATIVE_RANGE_TYPES = new Set([
  "thisWeek",
  "lastWeek",
  "thisMonth",
  "lastMonth",
  "thisYear",
  "allTime",
]);

export const isCustomRangeIncomplete = (filters) =>
  filters?.dateRangeType === "custom" &&
  (!filters?.customDateRange?.[0] || !filters?.customDateRange?.[1]);

export const getLeadsKpiLabel = (dateRangeType) => {
  switch (dateRangeType) {
    case "today":
      return "Leads Today";
    case "yesterday":
      return "Leads Yesterday";
    case "lastWeek":
      return "Leads Last Week";
    case "thisWeek":
      return "Leads This Week";
    case "thisMonth":
      return "Leads This Month";
    case "lastMonth":
      return "Leads Last Month";
    case "thisYear":
      return "Leads This Year";
    case "allTime":
      return "Leads (All Time)";
    case "custom":
      return "Leads (Custom Range)";
    default:
      return "Leads";
  }
};

export const buildAnalyticsQueryParams = (params = {}) => {
  const { filters, ...rest } = params;
  if (!filters?.dateRangeType) return { ...rest };

  const type = filters.dateRangeType;

  if (type === "allTime") {
    return { dateRangeType: "allTime", ...rest };
  }

  if (NATIVE_RANGE_TYPES.has(type)) {
    return { dateRangeType: type, ...rest };
  }

  const dates = resolveDateRangeParams(filters);
  if (!dates.startDate || !dates.endDate) {
    return { dateRangeType: "custom", ...rest };
  }

  return {
    dateRangeType: "custom",
    startDate: dates.startDate,
    endDate: dates.endDate,
    ...rest,
  };
};
